/**
 * LicenseBuilder Component Portal
 */

import { clearLicense, setEditingUsageIndex, setUsages } from '../../../../redux/actions/license';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import LicenseBuilder from './';

interface IOwnDispatchProps {
  clearLicense(): void;
  setEditingUsageIndex(): void;
  setUsages(): void;
}

export interface ILicenseBuilderPortalProps {
  scope?: ITermsScope;
  selectedUsage?: number;
  usages?: ILicenseUsage[];
  onClose(): void;
  onSaveLicense(usages: ILicenseUsage[]): void;
}

const defaultList = [];

class LicenseBuilderPortalBase extends React.Component<ILicenseBuilderPortalProps & IOwnDispatchProps> {
  componentDidMount() {
    this.props.setUsages();
    this.props.setEditingUsageIndex();
  }

  componentWillUnmount() {
    this.props.clearLicense();
  }

  render() {
    return ReactDOM.createPortal(
      <LicenseBuilder onClose={this.props.onClose} onSave={this.props.onSaveLicense} />,
      document.getElementsByClassName('drawer-wrapper')[0],
    );
  }
}

export const LicenseBuilderPortal = connect<{}, IOwnDispatchProps, ILicenseBuilderPortalProps, IStoreState>(
  null,
  (dispatch, { scope, selectedUsage, usages }) => ({
    clearLicense: () => dispatch(clearLicense()),
    setEditingUsageIndex: () => {
      if (selectedUsage != null) {
        dispatch(setEditingUsageIndex({ index: selectedUsage }));
      }
    },
    setUsages: () => dispatch(setUsages({ scope, usages: usages || defaultList })),
  }),
)(LicenseBuilderPortalBase);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/forms/LicenseBuilder/portal.tsx